export function getStormIcon(category: string | undefined): string {
  switch (category?.toLowerCase()) {
    case 'tornado':
      return 'tornado';
    case 'wind':
      return 'wind';
    case 'flood':
      return 'flood';
    case 'rain':
      return 'rain';
    case 'snow':
      return 'snow';
    case 'lightning':
      return 'lightning';
    case 'fog':
      return 'fog';
    case 'dust':
      return 'dust';
    case 'tropical':
      return 'hurricane';
    default:
      return 'marker';
  }
}

export const ICON_URLS = {
  tornado: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  wind: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
  flood: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
  rain: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
  snow: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
  lightning: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png',
  fog: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png',
  dust: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
  hurricane: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-violet.png',
  marker: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png'
};